import React, { FC, useEffect, useState } from 'react';
import SidebarStatuses from '../../components/Sidebar/components/SidebarStatuses/SidebarStatuses';
import { H3, Span } from '../../components/Text/Text';
import { AccessLevelE, ClientTypeE, StatusE } from '../../models/enums';
import { useAppSelector } from '../../store/hooks';
import { selectCurrentUser } from '../../store/selectors/authSelectors';
import useQueryParams from '../../utils/hooks/useQueryParams';
import { useNonDesktopViewport } from '../../utils/hooks/useNonDesktopViewport';

import styles from './styles.module.scss';

type CampaignListSidebarPropTypes = {
    onAfterStatusSelect?: () => void;
};

const CampaignListSidebar: FC<CampaignListSidebarPropTypes> = ({
    onAfterStatusSelect,
}) => {
    const { clientType, accessLevel } = useAppSelector(selectCurrentUser);
    const [filterCampaigns, setFilterCampaigns] = useState(false);
    const { addQueryParam, removeQueryParam } = useQueryParams();
    const [showProfile, setShowProfile] = useState(false);
    const isNonDesktop = useNonDesktopViewport();
    const isCLientTypeSuitableForFilter = (
        clientType === ClientTypeE['Advertising Agency'] ||
        clientType === ClientTypeE['Post/sound production'] ||
        clientType === ClientTypeE['Broadcaster'] ||
        clientType === ClientTypeE['Media Company']);

    // The "filter by action" checkbox only makes sense for client types that have an approval step
    // in the delivery flow. A media company has no such step, so it gets the status filter only.
    const hasActionFilter = (
        clientType === ClientTypeE['Advertising Agency'] ||
        clientType === ClientTypeE['Post/sound production'] ||
        clientType === ClientTypeE['Broadcaster']);

    useEffect(() => {
        if (filterCampaigns) {
            const filterStatus = getFilterTerm(clientType);

            addQueryParam({ actionNeed: 'true' });
        } else {
            removeQueryParam('actionNeed');
        }
    }, [filterCampaigns]);

    const getFilterTerm = (clientType: ClientTypeE) => {
        switch (clientType) {
            case ClientTypeE['Advertising Agency']: return StatusE.WaitingForApprovalOfAdvertisingAgency;
            case ClientTypeE['Post/sound production']: return StatusE.WaitingForApprovalOfPostProduction;
            case ClientTypeE['Broadcaster']: return StatusE.ApprovedAndSentToBroadcaster;
            default: return ''
        }
    };

    return isCLientTypeSuitableForFilter ? (
        <div className={styles.sidebarWrapper}>
            {hasActionFilter && accessLevel !== AccessLevelE.GlobalAdmin && (
                <>
                    <H3>Filter by action</H3>
                    <label htmlFor="filterCampaigns" className={styles.checkboxWrapper}>
                        <input
                            type="checkbox"
                            id='filterCampaigns'
                            name="filterCampaigns"
                            className={styles.checkbox}
                            checked={filterCampaigns}
                            onChange={(e) => {
                                setFilterCampaigns(e.target.checked);
                                if (isNonDesktop) {
                                    onAfterStatusSelect?.();
                                }
                            }}
                        />
                        <span className={styles.mark} />
                        <Span>
                            Display only campaigns with actions need to be taken
                        </Span>
                    </label>
                </>
            )}
            <SidebarStatuses
                setShowProfile={setShowProfile}
                isFooterHidden
                onAfterStatusSelect={onAfterStatusSelect}
            />
        </div>
    ) : <></>;
};

export default CampaignListSidebar;